/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconLogout/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconLogout({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconLogout",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconLogout.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1ja7YY': alignSelf,'--mt-2-1ja7YY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1ja7YY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1ja7YY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1ja7YY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1ja7YY': opacity,'--w-10-1ja7YY': typeof width === 'number' ? `${width}px` : width,'--h-11-1ja7YY': typeof height === 'number' ? `${height}px` : height,'--a-7-1ja7YY': isAnimated ? animation : "none",'--sd-8-1ja7YY': isAnimated ? strokeDashoffset : 0,'--sd-9-1ja7YY': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconLogout.SvgPath"
  data-view-path={viewPath}
 d="M17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"
 style={{'--f-12-1ja7YY': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}